import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IRestaurantCategoryStore,
} from '../../mobx-store/storeInterfaces/restaurantCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  restaurantCategoryStore: IRestaurantCategoryStore;
  countryStore: CountryStore;
  history: any;
  match: any;
}

@inject('restaurantCategoryStore')
@inject('countryStore')
@observer
class RestaurantCategories extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  restaurantId: number;

  constructor(props: IProps) {
    super(props);
    this.title = translate('restaurantCategoriesListPageTitle', {
    });
    this.restaurantId = this.props.match.params.restaurantId;
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.restaurantCategoryStore.updateCategoryStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/restaurants/${this.restaurantId}/categories/${this.props.restaurantCategoryStore.categoriesList[index].categoryId}/edit`,
    );
  };

  handleTableItemsButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/restaurants/${this.restaurantId}/categories/${this.props.restaurantCategoryStore.categoriesList[index].categoryId}/menus`,
    );
  };

  handelAdd = (): void => {
    this.props.history.push(`/restaurants/${this.restaurantId}/categories/new`);
  };

  getAddRestaurantButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getRestaurantTableHeader = () => [
    {
      title: translate('restaurantCategoriesListCategoryColumnTitle', {
      }),
    },
    {
      title: translate('restaurantCategoriesListStatusColumnTitle', {
      }),
    },
    {
      title: translate('restaurantCategoriesListItemsColumnTitle', {
      }),
    },
    {
      title: translate('restaurantCategoriesListEditColumnTitle', {
      }),
    },
  ];

  getRestaurantTableData = () => this.props.restaurantCategoryStore.categoriesList
    .map((category) => ({
      ...category,
      items: translate('restaurantCategoriesListItemsButton', {
      }),
      edit: translate('restaurantCategoriesListEditButton', {
      }),
    }));

  getRestaurantTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('restaurantCategoriesListStatusActive', {
      }),
      inactiveLabel: translate('restaurantCategoriesListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'items',
      onClick: this.handleTableItemsButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddRestaurantButton();
    this.tableHeader = this.getRestaurantTableHeader();
    this.tableData = this.getRestaurantTableData();
    this.tableCellTypes = this.getRestaurantTableCellTypes();
    return (
      <div>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.title} />
        <GeneralTableComponent
          emptyMessage={translate('restaurantCategoriesListNoCategoriesMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.restaurantCategoryStore.getRestaurantCategoriesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, restaurantCategoryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    restaurantCategoryStore.getCategories(this.restaurantId, countryStore.managedCountries, languageCodes.english);
  }
}

export default RestaurantCategories;
